// extracted by mini-css-extract-plugin
module.exports = {"bannerLink":"styles_bannerLink__28ZGb","banner":"styles_banner__2v2Lr","vertical":"styles_vertical__3HfC5","horizontal":"styles_horizontal__3qzgH"};